
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class Navbar extends Component {
  render() {
    return (
      <>
        <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark shadow-sm">
          <div className="container">
            {/* Brand / Logo */}
            {/* <Link className="navbar-brand fw-bold fs-4 text-warning" to="/">
              <i className="bi bi-newspaper me-2"></i>NewsPtuCoder
            </Link> */}
            <h3 className="navbar-brand fw-bold fs-4 text-warning bi bi-newspaper me-2"> NewsPtuCoder</h3>

            {/* Toggle button for mobile */}
            <button
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Menu Items */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto text-center">
                <li className="nav-item">
                  <Link className="nav-link active" to="/general">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/business">
                    Business
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/entertainment">
                    Entertainment
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/health">
                    Health
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/science">
                    Science
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/sports">
                    Sports
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/technology">
                    Technology
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-warning fw-semibold"
                    href="https://sahil-rauniyar-portfolio.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    About PtuCoder
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Navbar;



















// import React, { Component } from 'react';
// // import PropTypes from 'prop-types'
// import { Link } from 'react-router-dom';

// export class Navbar extends Component {
//     static propTypes = {

//     }

//     render() {
//         return (
//             <div>
//                 <>
//                     <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
//                         <div className="container-fluid">
//                             {/* <Link className="navbar-brand" to="/">NewsPtuCoder</Link> */}
//                             <h5>NewsPtuCoder</h5>
//                             <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//                                 <span className="navbar-toggler-icon"></span>
//                             </button>
//                             <div className="collapse navbar-collapse" id="navbarSupportedContent">
//                                 <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//                                     <li className="nav-item">
//                                         <Link aria-current="page" to="/general">Home</Link>
//                                     </li>
//                                     {/* <li className="nav-item">
//                                         <Link className="nav-link" to="/about">About</Link>
//                                     </li> */}
//                                     {/* <li> <Link className="nav-link" to="/">Home</Link></li> */}
//                                     <li> <Link className="nav-link" to="/business"> Business</Link></li>
//                                     <li> <Link className="nav-link" to="/entertainment"> Entertainment</Link></li>
//                                     <li> <Link className="nav-link" to="/general"> General</Link></li>
//                                     <li> <Link className="nav-link" to="/health"> Health</Link></li>
//                                     <li>  <Link className="nav-link" to="/science"> Science</Link></li>
//                                     <li>  <Link className="nav-link" to="/sports"> Sports</Link></li>
//                                     <li>  <Link className="nav-link" to="/technology"> Technology</Link></li>
//                                     <li><a className="nav-link" href="https://sahil-rauniyar-portfolio.netlify.app/">AboutPtuCoder</a></li>


//                                 </ul>
//                                 {/* <li><a className="nav-link" href="https://sahil-rauniyar-portfolio.netlify.app/">AboutPtuCoder</a></li> */}

//                             </div>
//                         </div>
//                     </nav>
//                 </>
//             </div>
//         )
//     }
// }

// export default Navbar

